import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Observable, map } from 'rxjs';
import { BreadcrumbItem, BreadcrumbsService } from '../services/breadcrumbs.service';

@Component({
    selector: 'app-breadcrumbs',
    templateUrl: './breadcrumbs.component.html',
    styleUrls: ['./breadcrumbs.component.scss'],
    standalone: true,
    imports: [CommonModule, RouterModule]
})
export class BreadcrumbsComponent {
  public readonly crumbs$: Observable<BreadcrumbItem[]>;
  public readonly shouldShow$: Observable<boolean>;

  public constructor(private readonly breadcrumbsService: BreadcrumbsService) {
    this.crumbs$ = this.breadcrumbsService.crumbs$;
    // Only show breadcrumbs when there are actual breadcrumb items (not on home page)
    this.shouldShow$ = this.crumbs$.pipe(
      map(crumbs => crumbs.length > 0)
    );
  }
}


